import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { forgotPassword, resetPassword } from "../api/api";

function ForgotPassword() {

  const navigate = useNavigate();

  const [step, setStep] = useState("mobile"); // mobile | reset | success

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleRequestOtp(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const data = await forgotPassword(mobile);
      setInfo(data.message);
      setStep("reset");
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    setError("");

    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setSubmitting(true);
    try {
      await resetPassword(mobile, otp, newPassword);
      setStep("success");
    } catch (err) {
      const status = err.response?.status;
      if (status === 400) {
        setError("Invalid or expired code. Please try again.");
      } else if (status === 429) {
        setError("Too many attempts. Please request a new code.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (

    <div className="login-page">

      {step === "mobile" && (

        <form className="login-box" onSubmit={handleRequestOtp}>

          <h1>🌿 Forgot Password</h1>

          <p className="login-subtitle">
            Enter your mobile number and we'll send you a code to reset it.
          </p>

          {error && (
            <p className="login-error" style={{ color: "red" }}>
              {error}
            </p>
          )}

          <input
            type="text"
            placeholder="Mobile Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />

          <button
            type="submit"
            className="login-btn"
            disabled={submitting}
          >
            {submitting ? "Sending..." : "Send Code"}
          </button>

          <button
            type="button"
            className="register-btn"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </button>

        </form>

      )}

      {step === "reset" && (

        <form className="login-box" onSubmit={handleResetPassword}>

          <h1>🌿 Reset Password</h1>

          <p className="login-subtitle">
            {info || `Enter the code sent to ${mobile} and choose a new password.`}
          </p>

          {error && (
            <p className="login-error" style={{ color: "red" }}>
              {error}
            </p>
          )}

          <input
            type="text"
            placeholder="Reset Code"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />

          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={submitting}
          >
            {submitting ? "Resetting..." : "Reset Password"}
          </button>

          <button
            type="button"
            className="register-btn"
            onClick={() => setStep("mobile")}
          >
            Change Mobile Number
          </button>

        </form>

      )}

      {step === "success" && (

        <div className="login-box">

          <h1>✅ Password Reset</h1>

          <p className="login-subtitle">
            Your password has been changed successfully. You can now sign in
            with your new password.
          </p>

          <button
            type="button"
            className="login-btn"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

        </div>

      )}

    </div>

  );
}

export default ForgotPassword;
